import { dbsKeys } from "data/dbsKeys";
import { generateId, readCollection, writeCollection } from "data/dbsStorage";

const EMPTY = [];

export const alertsRepo = {
  list() {
    return readCollection(dbsKeys.alerts, EMPTY);
  },

  create(alert) {
    const items = alertsRepo.list();
    const next = {
      id: generateId("alert"),
      createdAt: new Date().toISOString(),
      ...alert,
    };
    writeCollection(dbsKeys.alerts, [next, ...items]);
    return next;
  },

  remove(id) {
    const items = alertsRepo.list();
    writeCollection(dbsKeys.alerts, items.filter((a) => a.id !== id));
  },
};
